import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { FilterService } from './filter.service';
import { FilterHelper } from '../helpers/filter.helper';
import { Filter } from '../models/filter.model';
import { ItemFilterService } from './item.filter.service';
import { DealService } from './deal.service';
import { Deal } from '../models/deal.model';

@Injectable()
export class DealFilterService implements ItemFilterService {
  public filteredItems$: Observable<Deal[]>;
  private currentDeals: BehaviorSubject<Deal[]> = new BehaviorSubject<Deal[]>(
    [],
  );

  constructor(
    private dealService: DealService,
    private filterService: FilterService,
    private filterHelper: FilterHelper,
  ) {
    this.filteredItems$ = this.currentDeals.asObservable();
    this.filterService.currentFilter$.subscribe((currentFilter: Filter[]) => {
      const filteredDeals: Deal[] = this.filterHelper.filter(
        this.dealService.items,
        currentFilter,
      );
      this.currentDeals.next(filteredDeals);
    });
  }
}
